import { Plaque } from "./Plaque";
import { shortWallet, useAllTimeKings } from "./useLeaderboard";

/**
 * Cumulative reign-duration leaderboard. Ranks wallets by total seconds spent
 * as KotH king across every round.
 *
 * Data flows: @solblox/api -> useAllTimeKings -> here. Reign-duration is the
 * time-integral SUM(end_ts - start_ts) over the koth_king_reigns table —
 * a wallet that crowned 10× for 5s each ranks below one that crowned once
 * for 60s.
 */

interface AllTimeKingsPlaqueProps {
  position: [number, number, number];
  rotation?: [number, number, number];
  gameId?: string;
}

function formatReign(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
  return `${(seconds / 3600).toFixed(1)}h`;
}

export function AllTimeKingsPlaque({
  position,
  rotation,
  gameId = "koth",
}: AllTimeKingsPlaqueProps): JSX.Element {
  const { rows, error } = useAllTimeKings({ gameId, limit: 5 });

  let lines: string[];
  if (error && rows.length === 0) {
    lines = ["(offline)"];
  } else if (rows.length === 0) {
    lines = ["(no kings yet)"];
  } else {
    lines = rows.map(
      (r, i) => `${i + 1}. ${shortWallet(r.king)}   ${formatReign(r.reignSeconds)}`,
    );
  }

  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={3.4}
      height={2.6}
      backerColor="#1f1f2a"
      title="ALL-TIME KINGS"
      titleColor="#f4d36a"
      titleSize={0.22}
      lines={lines}
      bodyColor="#e8e8ef"
      bodySize={0.2}
      align="left"
    />
  );
}
